import './index.css'
import 'maplibre-gl/dist/maplibre-gl.css'
import '@maplibre/maplibre-gl-geocoder/dist/maplibre-gl-geocoder.css'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { MODALS_ROOT_ID, TOOLTIP_ROOT_ID } from './common/constants'
import './common/styles/color.variables.css'
import './common/styles/global.variables.css'
import './common/styles/typography.css'
import './i18n'
import reportWebVitals from './reportWebVitals'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
    <div id={MODALS_ROOT_ID} />
    <div id={TOOLTIP_ROOT_ID} />
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
